// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import cleanComment from './cleanComment'

// generic helper to prep comments for the specified dbSet.
const cleanAllComments = (comments, uniqueId) => (
  comments.reduce((a, d) => {
    a.push(cleanComment(d, uniqueId))
    return a
  }, [])
)

export default cleanAllComments
